/**
 * Created by daniel.gonzalez on 6/15/15.
 */

'use strict';

var $           = require('dibs-jquery-shim');
var SV          = require('server-vars');
var matConfigs  = require('global/mobileAds/matConfigs');

module.exports = {
    getAdName() {
        return this._adName;
    },

    getMATConfig() {
        let adName = this.getAdName();
        let env = SV.get('settings.environment');
        return matConfigs[adName][env] || matConfigs[adName].nonProduction;
    },

    /**
     * @param srcLink - A Mobile App Tracking link we need to open in an iframe to start a tracking session.
     *                  We open it in an iframe to hide the Mobile App Tracking bridge page. Normally, this bridge page
     *                  would redirect you to the itunes store or the app, but you cannot redirect to the itunes store
     *                  (or to an app in chrome) from an iframe. As a fallback, we are forcing a redirect after the
     *                  iframe has been loaded. We are also forcing an optional redirect in case the timeoutLink is an
     *                  app the user does not have and we want to redirect them to the app store to get that app.
     * @param timeoutLink - first fallback link
     * @param optionalLink - second (and optional) fallback link
     */
    redirectInIframe(srcLink, timeoutLink, optionalLink) {
        $('<iframe />')
            .attr('src', srcLink)
            .attr('style', 'display:none;')
            .appendTo('body');
        window.setTimeout(function () {
            window.location.href = timeoutLink;
        }, 300);

        if (optionalLink) {
            window.setTimeout(function () {
                window.location.href = optionalLink;
            }, 600);
        }
    }
};



// WEBPACK FOOTER //
// ./assets/js/global/mobileAds/mixins/baseMixin.es.js